module.exports = "<div class=\"sb-shell sb-fill-height\" ng-class=\"{'sb-visible-shell': $root.isShellVisible}\">\n  <toolbar ng-if=\"$root.isShellVisible\"></toolbar>\n\n  <section layout=\"row\" flex class=\"sb-fill-height\">\n    <sidenav ng-if=\"$root.isShellVisible\"></sidenav>\n\n    <md-content flex>\n      <div ui-view></div>\n    </md-content>\n  </section>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/layout/shell/shell.html
// module id = 441
// module chunks = 0